/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from "react";

export const EmptyValue = (props) => {
    return <span className="sb-empty-value">(None)</span>
};
